<template>
  <b-col md="2" sm="2" xl="2" v-if="!item.is_del && item.is_alive || item.is_del && use_view == false">
    <b-card @click="detail(item)" :style="{ cursor: 'pointer'}">
      <small>
        Status:
        <b-badge variant="success" v-if="list.indexOf(item.id) > -1 || item.alive">Online</b-badge>
        <b-badge variant="secondary" v-else-if="item.is_alive">Offline</b-badge>
        <b-badge v-else>Disable</b-badge>
        <br>
        <!-- <span class="ml-1"></span>|<span class="ml-1"></span> -->
        <span>Mode : </span>
        <b-badge v-if="item.mode == 0 || !item.mode" >Off</b-badge>
        <b-badge v-if="item.mode == 1" variant="warning">Detect</b-badge>
        <b-badge v-else-if="item.mode == 2" variant="danger">Block</b-badge>
      </small>
      <hr>
      <span class="font-weight-bold">{{item.nickname || '-'}}</span>
      <br>
      <small>{{item.ip_addr}}</small>
    </b-card>
  </b-col>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
